import React from 'react';
import styled from '@emotion/styled';
import { IUserGraphQL } from '@biproxi/models/interfaces/IUser';
import Flex from '../../elements/Flex';
import Colors from '../../styles/Colors';
import Text, { TextTypesEnum } from '../../elements/Text';
import Icon, { Icons } from '../../elements/Icon';
import { media, useMobileMedia } from '../../utils/MediaQuery';
import Divider from '../../elements/Divider';
import Tag from '../../elements/Tag';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 40px 0px;
  box-sizing: border-box;

  ${media.mobile} {
    padding: 0px;
    flex-direction: column;
    justify-items: flex-start;
  }

  ${media.tablet} {
    width: calc(100% - 32px);
  }
`;

const SectionTitle = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0px 40px 0px 0px;

  ${media.mobile} {
    width: 100%;
    padding: 40px 0px;
  }
`;

const IntegrationFlexItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  width: 100%;
`;

const MobileSpacer = styled.div`
  height: 40px;
`;

export type SettingsIntegrationsProps = {
    user: IUserGraphQL;
}

const SettingsIntegrations: React.FC<SettingsIntegrationsProps> = ({ user }) => {
  /** Hooks */
  const isMobile = useMobileMedia();

  /** Render */
  const googleConnected = Boolean(user?.oAuthProviders?.google);
  const linkedinConnected = Boolean(user?.oAuthProviders?.linkedin);

  return (
    <Container>
      <SectionTitle>
        <Flex>
          <Text
            type={TextTypesEnum.Bold18}
            color={Colors.Black}
          >
            Integrations
          </Text>
          {/* <Icon
            icon={Icons.InfoSquareSolid}
            size={14}
            color={Colors.Grey400}
            margin="0px 0px 0px 8px"
          /> */}
        </Flex>
        <Text
          type={TextTypesEnum.Regular14}
          color={Colors.Grey700}
        >
          Enrich your Biproxi experience with third-party integrations.
        </Text>
      </SectionTitle>
      <Flex direction="column" width={isMobile ? '100%' : '60%'}>
        <IntegrationFlexItem>
          <Icon
            icon={Icons.Google}
            size={24}
            margin="0px 8px 0px 0px"
            color={Colors.Grey900}
          />
          <Text
            type={TextTypesEnum.Regular16}
            color={Colors.Grey900}
            margin="0px 8px 0px 0px"
          >
            Sign in with Google
          </Text>
          <Tag
            text={googleConnected ? 'Verified' : 'Not connected'}
            color={googleConnected ? 'Green' : 'Grey'}
          />
        </IntegrationFlexItem>
        <Divider margin="32px 0px" />
        <IntegrationFlexItem>
          <Icon
            icon={Icons.Linkedin}
            size={24}
            margin="0px 8px 0px 0px"
            color={Colors.Grey900}
          />
          <Text
            type={TextTypesEnum.Regular16}
            color={Colors.Grey900}
            margin="0px 8px 0px 0px"
          >
            Sign in with Linkedin
          </Text>
          <Tag
            text={linkedinConnected ? 'Verified' : 'Not connected'}
            color={linkedinConnected ? 'Green' : 'Grey'}
          />
        </IntegrationFlexItem>
      </Flex>
      {isMobile && (
        <MobileSpacer />
      )}
    </Container>
  );
};

export default SettingsIntegrations;
